import React from 'react'
import { formatCurrency } from '../../../lib/utils/formatNumber'
import { Vehicle } from '../../../lib/types/Vehicle'
import { ImageGallery } from '@demandlocal/components'
import FallbackImage from './../../../images/fallback_car.png'
import cleanUrl from '../../../lib/utils/cleanURL'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

const GridItemVehicle = ({ item }: { item: Vehicle }): JSX.Element => {
  const images = (item?.image_url?.match(/https:\/\/.*?(?=\|\|\|\||\|https|,https|;https|$)/) || []).map(cleanUrl)
  const navigate = useNavigate()
  return (
    <div className={'rounded-lg overflow-hidden'}>
      <div
        className={'h-[220px] cursor-pointer'}
        onClick={() => navigate(`../vehicles/${item.vin_number}`)}>
        <ImageGallery
          fallbackImage={FallbackImage}
          key={item?.vin_number}
          images={images}
        />
      </div>
      <div className={'flex flex-col gap-3 bg-cultured-gray text-primary-xiketic p-5'}>
        <span
          className={'text-base font-bold cursor-pointer'}
          onClick={() => navigate(`../vehicles/${item.vin_number}`)}>
          {item.make ?? ''} {item?.model ?? ''}
        </span>
        <div
          className={'flex flex-col font-medium text-xs gap-1 cursor-pointer'}
          onClick={() => navigate(`../vehicles/${item.vin_number}`)}>
          <span>VIN: {item?.vin_number}</span>
          <span>Mileage: {item?.mileage || 'N/A'}</span>
          <span>Year: {item?.year || 'N/A'}</span>
          <span>Days on Lot: {item?.days_on_lot || 'N/A'}</span>
          <span>Last Seen: {dayjs(item?.last_seen).format('YYYY-MM-DD') || 'N/A'}</span>
        </div>
        <div>
          <a
            href={item?.raw_vehicle_destination_url}
            target={'_blank'}
            className={'text-primary-persian-blue font-bold text-sm'}
            rel="noreferrer">
            View on source
          </a>
        </div>
        <div>
          <span className={'text-base font-bold'}>
            Price: {formatCurrency(Number(item?.price) || 0)}
          </span>
        </div>
      </div>
    </div>
  )
}

export default GridItemVehicle
